import { render, staticRenderFns } from "./passportDialog.vue?vue&type=template&id=e4998558"
import script from "./passportDialog.vue?vue&type=script&lang=js"
export * from "./passportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports